import { reactive } from 'vue'

export default function InstallSpinner (NetteAjax) {
  return NetteAjax.ext('spinner', {
    before: function (settings) {
      let spinners = []

      if (settings.nette && settings.nette.ui && settings.nette.ui.getAttribute('data-spinner')) {
        const rawSpinners = settings.nette.ui.getAttribute('data-spinner')
        /* if (rawSpinners.indexOf('[') === 0) {
          settings.off = $el.data('ajaxOff');
        } else */if (rawSpinners.indexOf(',') !== -1) {
          spinners = rawSpinners.split(',')
        } else if (rawSpinners.indexOf(' ') !== -1) {
          spinners = rawSpinners.split(' ')
        } else {
          spinners = rawSpinners
        }

        if (typeof spinners === 'string') spinners = [spinners]
          spinners.map(val => val.trim())
        } else if (settings.route) {
          spinners.push(settings.route.query.snippetName ? settings.route.query.snippetName : 'root')
        } else {
          let url = settings.url
          if (url) {
            if (url.substring(0, 4) !== 'http') {
              url = window.location.origin + url
            }

            const route = NetteAjax.ext('vue-router').urlToRoute(url)
            console.log('spinner route', route)
            if (route.query.snippetName) {
              spinners.push(route.query.snippetName)
            } else {
              spinners.push('Content')
            }
          } else {
              spinners.push('Content')
          }
          spinners.push('always')
        }

      for (let i = 0; i < spinners.length; i++) {
        if (this.aliases[spinners[i]]) {
          spinners.push(...this.aliases[spinners[i]])
        }
      }
      if (spinners.indexOf('root') !== -1) {
        spinners = ['root']
      }

      settings.spinners = spinners
      spinners.forEach((spinner) => {
        if (spinner in this.spinners) {
          this.spinners[spinner] = true
        }
      })
    },
    complete: function (response, success, settings) {
      if (settings.spinners) {
        settings.spinners.forEach((spinner) => {
          if (spinner in this.spinners) {
            this.spinners[spinner] = false
          }
        })
      }
    }
  }, {
    spinners: reactive({}),
    aliases: {},
    /*
    install(Vue, options) {
      // this.spinners = Vue.observable(this.spinners)
      // Vue.component('aw-spinner', AwSpinner)
      // this.aliases = { ...this.aliases, ...(options || {}) }
    }
    */
  })
}
